<template>
  <div class="py-10 lg:py-32 relative banner">
    <h1 class="text-4.5xl lg:text-5xl text-semantic-surface-on-surface lg:leading-tight">
      <b>{{ props.title }}</b>
      <br class="hidden md:block" />
      <template v-if="props.hasExplained">
        Explained
      </template>
    </h1>
    <client-only>
      <nuxt-img
        v-if="devices.isDesktop.value"
        class="absolute -z-10 hidden lg:block banner-img top-0 right-0 w-full h-full object-cover object"
        width="540"
        height="141"
        :src="props.coverImage"
        :alt="props.title"
      />
    </client-only>
  </div>
</template>

<script setup>
const { devices } = deviceChecker()

defineOptions({
  name: 'AtomsBanner'
})

const props = defineProps({
  title: {
    type: String,
    default: 'Title'
  },

  coverImage: {
    type: String,
    default: null
  },
  hasExplained: {
    type: Boolean,
    default: true
  }
})
</script>

<style scoped>
.banner-img {
  object-position: 0 68%;
}
</style>
